module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_0.c20e4fc5.png";